import Fade from "react-reveal/Fade";
import {
  HeroContainer,
  HeroWrapper,
  HeroRow,
  Column1,
  Column2,
  TextWrapper,
  Heading,
  Subtitle,
  JoinDescription,
  CTASection,
  ImgWrap,
  Img,
} from "./HeroElements";
import CustomButton from "../Button";
import styled from "styled-components";

const JoinButton = styled(CustomButton)``;
const HeroSection = ({ id, headline, description, imgStart, img, alt }) => {
  return (
    <>
      <HeroContainer id={id}>
        <HeroWrapper>
          <HeroRow imgStart={imgStart}>
            <Fade left>
              <Column1>
                <TextWrapper>
                  <Heading>{headline}</Heading>
                  <Subtitle>{description}</Subtitle>
                </TextWrapper>
                <JoinDescription>
                  Join the #PaythumbSlackCommunity and get involved in our
                  Q&A's, live chats, beta releases and more.
                </JoinDescription>
                <CTASection>
                  <JoinButton
                    onClick={() =>
                      window.open(
                        "https://communityinviter.com/apps/paythumbcommunity/paythumb-community",
                        "_blank"
                      )
                    }
                  >
                    Join Our Slack Community
                  </JoinButton>
                </CTASection>
              </Column1>
            </Fade>
            <Column2>
              <ImgWrap>
                <Img src={img} alt={alt} />
              </ImgWrap>
            </Column2>
          </HeroRow>
        </HeroWrapper>
      </HeroContainer>
    </>
  );
};

export default HeroSection;
